import { classify } from 'sidecar-utilities'

// While the icon for the button is wrapped in an actual button, the button
// is only for functionality. Icons are the things that get styled.
// Size is a separate prop, not part of the className (see Icon for info)
export const ornamentStyles = `absolute top-5 color-icon-default`

// the button and it's icon are grouped together so that the icon can
// change states based on user interaction with the button.
export const buttonIconStyles = classify({
  hover: 'group-hover/button:color-icon-hover',
  active: 'group-active/button:color-icon-active',
  focus: 'group-focus/button:color-icon-active',
})

// The "field" is basically the div that wraps the everything. It helps
// keep everything together inside of the input. The input is made to
// visually encompass these things with extra padding so that we can leverage
// it's hover, focus and other states for styling.
export const fieldStyles = 'relative flex w-full'

export const inputStyles = ({ button, disabled, error, label }) =>
  classify({
    layout: 'w-full h-16 rounded-lg border peer',
    color: 'color-bgDefault color-textOnDefault',
    spacing: 'pl-4 pt-7 pb-3',
    cursor: disabled ? 'cursor-not-allowed' : 'cursor-text',
    // If the field is disabled, we don't do any of the
    // interactive styling (hover, focus, etc).
    disabledBorder: disabled && 'color-border-disabled',
    errorBorder:
      error &&
      'color-borderRisk hover:color-borderRisk-hover active:color-borderRisk-active',
    defaultBorder:
      !disabled &&
      !error &&
      'color-borderDefaultDecorStrong hover:color-borderDefaultDecorStrong-hover',
    active:
      !disabled &&
      !error &&
      'active:color-borderDefaultDecorStrong-active active:outline active:outline-2 active:color-outlinePrimaryDecor',
    focused:
      !disabled &&
      'focus:outline focus:outline-2 focus:color-borderDefaultDecorStrong-active focus:color-outlinePrimaryDecor',
    withPlaceholder:
      label &&
      `placeholder:text-transparent focus:placeholder:color-text-disabled`,
    padding: !button ? 'pr-4' : 'pr-13',
  })

// The label comes after the input so that the input can be used as a "peer"
// and control the way that the label looks depending on it's various states.
// The label should be positioned right where the input text will be and it
// should move out of the way when a user focuses to type. It should also
// help display the state of the field.
export const labelStyles = ({ error, value }) =>
  classify({
    layout: `absolute left-4`,
    withValue: value ? 'text-xs top-3' : 'top-5',
    color: error ? 'color-textRisk' : 'color-textPrimary',
    disabled: 'peer-disabled:color-text-disabled',
    invalid: 'peer-invalid:color-textRisk',
    focused: 'peer-focus:text-xs peer-focus:top-3 peer-focus:color-textPrimary',
    animation: 'transition-all',
  })
